import React from 'react';
import { NumberInputRow } from '@/components/form/NumberInputRow';
import { AnimatedFormError } from '@/components/form/AnimatedFormError';


interface Props {
  flatRateAmountProps?: Record<string, unknown>;
  flatRateAmountError?: React.ReactNode;
}

export const FlatRateSection: React.FC<Props> = ({
  flatRateAmountProps,
  flatRateAmountError,
}) => {
  return (
    <div>
      <NumberInputRow
          id="flat-rate-amount"
          label="Flat Rate Amount"
          description="Fixed premium amount added to the shift when overnight premium applies."
          unit="$"
          unitPosition="left"
          inputProps={flatRateAmountProps ?? {}}
          errorElement={<AnimatedFormError>{flatRateAmountError}</AnimatedFormError>}
        />
    </div>
  );
};
